import React from 'react';

// @mui/icons-material

import Info from "@mui/icons-material/Info";
import ListAlt from "@mui/icons-material/ListAlt";
import Beenhere from "@mui/icons-material/Beenhere";
import Receipt from "@mui/icons-material/Receipt";
import AddCircle from "@mui/icons-material/AddCircleOutline";
import RemoveCircle from "@mui/icons-material/RemoveCircleOutline";

import Button from '../components/Button.jsx';

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import OthelloWaiting from '../componentsothello/OthelloWaiting.jsx';
import OthelloTimer from '../componentsothello/OthelloTimer';
import OthelloComboBox from '../componentsothello/OthelloComboBox.jsx';
import OthelloCard from '../componentsothello/OthelloCard.jsx';
import OthelloTitulo from '../componentsothello/OthelloTitulo.jsx';

import { TiposBusquedaEstadisticas, TiposPreguntaEncuenta, TipoPreguntaEncuenta, OpcionSiNoEncuesta, OpcionComboBienMalRegularEncuesta, OpcionComboUnoDiezEncuesta, OpcionEstrellasEncuesta } from "../othelloConstantes.jsx";

import { TipoBusquedaEstadisticas } from '../othelloConstantes.jsx';
import OthelloEdit from '../componentsothello/OthelloEdit.jsx';
import OthelloPrimary from '../componentsothello/OthelloPrimary.jsx';
import OthelloTituloPanelData from '../componentsothello/OthelloTituloPanelData.jsx';

export default function EncuestasEstadistica({ ...props })
{

    //Gestion de filtros
    const [loadingFiltros, setLoadingFiltros] = React.useState(true);
    const [filtros, setFiltros] = React.useState("");

    //Gestion de la lista de entregas traspasos
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState(null);

    const [questionOpen, setQuestionOpen] = React.useState([]);

    //EFECTOS

    React.useEffect(() => {
        fetch('api/Data/GetFiltrosEncuestasEstadisticas')
            .then(response => response.json())
            .then(data => {
                setFiltros(data);
                setLoadingFiltros(false);
            }).catch(error => {

            });

    }, [loadingFiltros]);
  

    function getDataPage() {

        //Obtengo los datos
        let formulario = document.getElementById('formbusqueda');
        let formData = new FormData(formulario);
        //const data = new FormData(this.refs.form);

        setLoading(true);

        fetch('api/Data/GetEncuestasEstadisticas', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {

            setData(res);
            setLoading(false);

        }).catch(error => {
            setData(null);
            setLoading(false);
        });
    }

    const onChangeEncuesta = (valor) => {
        if (valor != null) {
            let nuevo = { ...filtros }
            nuevo.tipobusqueda = valor;
            setFiltros(nuevo);
        }
    }

    const onChangeTipo = (valor) =>
    {
        if (valor != null)
        {
            let nuevo = { ...filtros }
            nuevo.tipobusqueda = valor;
            setFiltros(nuevo);
        }
    }

    const OnBuscarClick = () =>
    {
        getDataPage();
    }

    const onClickCollapse = (index) =>
    {
        if (index != null && index >= 0)
        {
            let existe = questionOpen.includes(index);

            if (existe) {
                let nuevo = [];
                questionOpen.forEach(x => {
                    if (x != index)
                        nuevo.push(x);
                });

                setQuestionOpen(nuevo);
            }
            else {
                var array = [...questionOpen]; 
                
                array.push(index);
                setQuestionOpen(array);    
            }
        }
    }

    // render

    function renderParametrosBusqueda() {

        return (<Grid container>
            <Grid item xs={12} sm={12} md={12}>
                <OthelloTituloPanelData margentop={1}>
                    <div>
                        <form id="formbusqueda" >   
                            <Grid container mb={1}>
                                <Grid item xs={3} sm={2} md={2} lg={1} mt={1}>
                                <Button color='info' size="sm" onClick={OnBuscarClick}>Buscar</Button>
                            </Grid>
                            <Grid item xs={5} sm={5} md={4} lg={3}>
                                <OthelloComboBox label='Encuesta' fieldname="id_encuesta" items={!loadingFiltros ? filtros.encuestas : []} onChange={onChangeEncuesta}  currentvalue={!loadingFiltros ? filtros.id_encuestadefault : 0}/>
                            </Grid>
                            <Grid item xs={4} sm={4} md={4} lg={2}>
                                    <OthelloComboBox label='Periodo' fieldname="tipobusqueda" items={TiposBusquedaEstadisticas} onChange={onChangeTipo} currentvalue={!loadingFiltros ? filtros.tipobusqueda :0} />                                                        
                            </Grid>
                            {filtros != null && filtros.tipobusqueda == TipoBusquedaEstadisticas.Personalizado ?
                                        <>
                                            <Grid item xs={6} sm={3} md={3} lg={2}>
                                                <OthelloTimer label="Desde" fieldname="desde" />
                                            </Grid>
                                            <Grid item xs={6} sm={3} md={3} lg={2}>
                                                <OthelloTimer label="Hasta" fieldname="hasta" />
                                            </Grid>
                                        </>: ""
                            }
                            </Grid>
                        </form>
                    </div>
                </OthelloTituloPanelData>
            </Grid>
        </Grid>)
    }


    function renderInfoDetallePregunta(question, tiposinpuntuacion) {

        let resdata = "";
        let array = [];

        if (question.tipo == TipoPreguntaEncuenta.ComboUnoDiez)
            array = OpcionComboUnoDiezEncuesta;
        else if (question.tipo == TipoPreguntaEncuenta.ComboBienMalRegular)
            array = OpcionComboBienMalRegularEncuesta;
        else if (question.tipo == TipoPreguntaEncuenta.Estrellas)
            array = OpcionEstrellasEncuesta;
        else if (question.tipo == TipoPreguntaEncuenta.SiNo)
            array = OpcionSiNoEncuesta;
        else if (question.tipo == TipoPreguntaEncuenta.Combo || TipoPreguntaEncuenta.PreSelecOpcion || question.tipo == TipoPreguntaEncuenta.Provincias || question.tipo == TipoPreguntaEncuenta.Paises)
        {
            if (question.resultados != null && question.resultados.length > 0) 
                question.resultados.forEach(x => {
                    if (x.resultexto != null)
                        array.push({ valor: x.resultexto, name: x.resultexto })
                });            
        }           

        if (array != [])
        {
            resdata = array.map(x =>
            {
                let valor = 0;

                if (question.resultados != null && question.resultados.length > 0)
                {
                    let resvalor = tiposinpuntuacion ? question.resultados.find(y => y.resultexto == x.valor) : question.resultados.find(y => y.puntuacion == x.valor);

                    if (resvalor != null)
                        valor = resvalor.respuestas;
                }

                return <Grid container style={{  margin: 5 }}>
                    <div style={{ width: 110 }}>
                        <b>{x.name}</b>
                    </div>
                    <div style={{ width: 250 }}>
                        <b style={{ color: '#9c27b0', marginRight: 4 }}>{valor}</b> respuestas
                    </div>
                </Grid>
            });
        }

        return <div style={{ marginLeft: 20, marginTop: 15 }}>{resdata}</div>;
    }

    function renderInfoPreguntaOpen(question, tiposinpuntuacion) {

        return (<div style={{ backgroundColor: '#ffffff', padding: 20, borderRadius: 3, marginBottom: 10, border: '0.5px solid', borderColor:'#efefef' }}>
            <Grid container>
                <Grid item xs={6} sm={6} lg={2}>
                    <OthelloComboBox label='Tipo' items={TiposPreguntaEncuenta} currentvalue={question.tipo} disabled={true}/>
                </Grid>
                <Grid item xs={6} sm={6} lg={2}>
                    <OthelloEdit label='Total Respuestas' currentvalue={question.totalRespuestas} readonly={true} />
                </Grid>
            </Grid>
            <OthelloPrimary style={{ marginBottom: 10 }}><b>Detalle de los resultados</b></OthelloPrimary>
            {renderInfoDetallePregunta(question, tiposinpuntuacion)}            
        </div>);         
    }

    function renderInfoPreguntas() {
         
        if (data.preguntas != null && data.preguntas.length > 0) {

            let res = data.preguntas.map((x, index) =>
            { 
                let open = questionOpen != null && questionOpen.length > 0 && questionOpen.includes(index);
                let tiposinpuntuacion = x.tipo == TipoPreguntaEncuenta.Combo || TipoPreguntaEncuenta.PreSelecOpcion || x.tipo == TipoPreguntaEncuenta.Provincias || x.tipo == TipoPreguntaEncuenta.Paises || x.tipo == TipoPreguntaEncuenta.TextoLibre;

                return <><div style={{ backgroundColor: '#efefef', height: 40, color: '#000000', paddingLeft: 15, textAlign: 'justify', fontSize: 18, borderRadius: 3, marginBottom: open ? 1 : 15, paddingRight: 5 }}>
                    <div style={{ float: 'right' }}>
                        {tiposinpuntuacion ? "" : <color style={{ backgroundColor: '#3b5998', color: '#ffffff', marginRight: 20, margintTop: 6, borderRadius: 3, padding: 4 }}>{x.valMedia.toFixed(2)}</color>}<Button color="info" justIcon size='sm' onClick={() => onClickCollapse(index)}>{open ? <RemoveCircle /> : <AddCircle />}</Button></div>
                            <p style={{ paddingTop: 10, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{x.pregunta}</p>
                </div>
                    <div>
                        {open ? renderInfoPreguntaOpen(x, tiposinpuntuacion) : "" }
                        </div>
                </>;                
            });

            return <Grid container mt={4}>
                <Grid item xs={12} sm={12} md={12}>
                    <OthelloTituloPanelData>
                        <div>
                            <OthelloTitulo titulo={"Resultado de la encuesta por pregunta " + data.desde + " - " + data.hasta} />
                            {res}
                        </div>
                    </OthelloTituloPanelData>
                </Grid>
            </Grid>
        }
        else
            return "";       
    }

    function renderInfoEstadisticas() {

        return (
            !loading && data != null ?  
                <>
            <Grid container>
                <Grid item xs={12} sm={6} md={4} lg={4}>
                            <OthelloCard color="error" categoria="Media" titulo={data.valMedia.toFixed(2)} icono="beenhere" footer="Valoracion media de la encuesta para el periodo" iconofooter="info" />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={4}>
                            <OthelloCard color="success" categoria="Encuentas" titulo={data.totalEncuestas} icono="receipt" footer="Encuestas realizas en el periodo" iconofooter="info" />
                        </Grid>    
                        <Grid item xs={12} sm={4} md={4} lg={4}>
                            <OthelloCard color="warning" categoria="Preguntas" titulo={data.totalPreguntas} icono="listalt" footer="Numero de preguntas distintas de la encuesta" iconofooter="info" />
                        </Grid>
                    </Grid>
                    {renderInfoPreguntas()}            
                </>
                :
                <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                        <OthelloTituloPanelData margentop={1}>
                            <div>
                                {loading ? < OthelloWaiting /> : "Seleccione los paramateros busqueda"}
                        </div>
                        </OthelloTituloPanelData>
                    </Grid>
                </Grid>);
    }

    let paramsbsuqueda = renderParametrosBusqueda();

    let infoestadisticas = renderInfoEstadisticas();


    return (<>
        {paramsbsuqueda}
        {infoestadisticas}        
    </>);
}


EncuestasEstadistica.propTypes = {


}